/**
 * FisPointsModal — Download FIS points CSVs by list number.
 * Auto-detects the current list period from listPeriods2026.json.
 */
import React, { useState, useMemo } from 'react';
import listPeriods from '../data/listPeriods2026.json';
import './PointsModal.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const fmtDate = (iso) => { const [,m,d] = iso.split('-'); return `${MONTHS[+m-1]} ${+d}`; };

function FisPointsModal({ isOpen, onClose, raceDate }) {
  const currentList = useMemo(() => {
    const today = new Date().toISOString().slice(0, 10);
    return listPeriods.fis.lists.find(l => today >= l.validFrom && today <= l.validTo) || null;
  }, []);

  const [pointsList, setPointsList] = useState('');
  const [distanceURL, setDistanceURL] = useState(null);
  const [sprintURL, setSprintURL] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const effectiveList = pointsList || (currentList ? String(currentList.code) : '1');

  const handleFetch = () => {
    setIsLoading(true);
    setError(null);
    const body = new FormData();
    body.append('pointsList', effectiveList);
    body.append('racers', []);
    body.append('return_csv', true);

    fetch('https://ggpwjy2pju3cttzzmoxhnuidyi0bkuwd.lambda-url.us-west-2.on.aws', {
      method: 'POST',
      body,
    })
      .then(res => res.json())
      .then(data => {
        setDistanceURL(data.distance);
        setSprintURL(data.sprint);
        setIsLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setDistanceURL(null);
    setSprintURL(null);
    setPointsList('');
    setError(null);
    onClose();
  };

  return (
    <div className="points-modal-overlay" onClick={handleClose}>
      <div className="points-modal" onClick={e => e.stopPropagation()}>
        <div className="points-modal-header">
          <h2>Download FIS Points</h2>
          <button className="points-modal-close" onClick={handleClose}>&times;</button>
        </div>
        {currentList && (
          <div className="points-modal-period">
            List {currentList.code} — valid {fmtDate(currentList.validFrom)} to {fmtDate(currentList.validTo)}
            {currentList.publishDate && <span className="period-published"> (published {fmtDate(currentList.publishDate)})</span>}
          </div>
        )}
        <div className="points-modal-form">
          <label>List #</label>
          <input
            type="text"
            value={pointsList}
            onChange={e => setPointsList(e.target.value)}
            placeholder={currentList ? String(currentList.code) : '1'}
          />
          <button onClick={handleFetch} disabled={isLoading}>
            {isLoading ? 'Loading\u2026' : 'Get FIS Lists'}
          </button>
        </div>
        {error && <div className="points-modal-error">{error}</div>}
        {(distanceURL || sprintURL) && (
          <div className="points-modal-links">
            {distanceURL && <a href={distanceURL} download="fis_distance.csv">Download Distance CSV</a>}
            {sprintURL && <a href={sprintURL} download="fis_sprint.csv">Download Sprint CSV</a>}
          </div>
        )}
      </div>
    </div>
  );
}

export default FisPointsModal;
